import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AppConfigService} from "projects/nter-ui-kit/src/lib/framework/config/app-config.service";
import {BaseService} from "projects/nter-ui-kit/src/lib/framework/common/base.service";
import {User, UserUpdateRequest} from "projects/nter-ui-kit/src/lib/framework/security/model/user.model";

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseService {
  protected readonly baseUrl: string;
  protected readonly baseRbacUrl: string;

  constructor(protected http: HttpClient, config: AppConfigService) {
    super();
    this.baseUrl = config.environment.apiSecurityHost + '/api/user';
    this.baseRbacUrl = config.environment.apiSecurityHost + '/console/rbac/user';
  }

  updateUserDetails(request: UserUpdateRequest): Observable<User> {
    return this.http.post<User>(this.baseUrl, request, this.options);
  }

  loadUser(userId: number): Observable<User> {
    const uri = this.baseUrl + '/' + userId;
    return this.http.get<User>(uri, this.options);
  }
}
